import React from "react";
import HighlightServices from "./HighlightServices/HighlightServices";
import ServiceSection from "./ServiceSection/ServiceSection";
import Contactus from "../CommonPage/Contact/Contactus";
import TestimonialSection from "./TestimonialSection/TestimonialSection";
import FaqSection from "./FaqSection/FaqSection";
import ScamAlertBanner from "../common_components/scamAlertBanner/ScamAlertBanner";

function Career_Solutions() {
  return (
    <>
      <HighlightServices />

      <ServiceSection />

      <Contactus />

      <TestimonialSection />

      <FaqSection/>

      <ScamAlertBanner/>
    </>
  );
}

export default Career_Solutions;
